var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#00C853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 9.65642C24.3743 9.93751 23.7029 10.1281 22.9976 10.2132C23.7178 9.77597 24.2691 9.08239 24.5304 8.25847C23.8548 8.66342 23.1091 8.95746 22.3145 9.11686C21.6782 8.42866 20.7731 8 19.7692 8C17.8432 8 16.2817 9.5832 16.2817 11.5347C16.2817 11.8115 16.3125 12.0818 16.372 12.3403C13.474 12.1928 10.9043 10.7851 9.18445 8.64618C8.88381 9.16747 8.71278 9.77487 8.71278 10.4233C8.71278 11.65 9.32892 12.7324 10.2638 13.3656C9.69222 13.3462 9.1547 13.1868 8.68411 12.9219V12.9661C8.68411 14.6785 9.88664 16.1077 11.4811 16.4329C11.189 16.5126 10.8809 16.5568 10.5623 16.5568C10.3371 16.5568 10.1193 16.5342 9.90575 16.4911C10.3498 17.8966 11.6373 18.9187 13.1628 18.9467C11.9698 19.8944 10.4656 20.4577 8.83178 20.4577C8.55028 20.4577 8.273 20.4405 8 20.4093C9.54353 21.4141 11.376 22 13.3455 22C19.7607 22 23.2674 16.6128 23.2674 11.9408L23.2557 11.4831C23.9409 10.9876 24.5336 10.3651 25 9.65642Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.24af07d0090a0d84d518dd9505296dd9.svg";
export { ForwardRef as ReactComponent };